import { useState } from "react";
import { Menu, Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { LanguageSelector } from "./LanguageSelector";
import { MissionsMenu } from "./MissionsMenu";
import { NotificationsMenu } from "./NotificationsMenu";
import { AuthButton } from "@/components/auth/AuthButton";
import { HeaderLogo } from "./HeaderLogo";
import { useLanguage } from "@/contexts/LanguageContext";
import { useUserRoles } from "@/hooks/useUserRoles";

export const MobileHamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { t, language } = useLanguage();
  const { isAdmin } = useUserRoles();

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="text-gray-600 dark:text-gray-300 md:hidden"
        >
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent 
        side="right" 
        className="w-80 bg-white dark:bg-gray-900 border-l border-gray-200 dark:border-gray-700"
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-center p-4 border-b border-gray-200 dark:border-gray-700">
            <HeaderLogo />
          </div>

          {/* Menu Items */}
          <div className="flex-1 overflow-y-auto p-4">
            <div className="space-y-6">
              {/* Theme Toggle */}
              <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
                <span className="text-sm font-medium">Theme</span>
                <ThemeToggle />
              </div>

              {/* Language Selector */}
              <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
                <span className="text-sm font-medium">Language</span>
                <LanguageSelector />
              </div>

              {/* Missions */}
              <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
                <span className="text-sm font-medium">Work Instructions</span>
                <MissionsMenu />
              </div>

              {/* Notifications */}
              <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
                <span className="text-sm font-medium">Notifications</span>
                <NotificationsMenu />
              </div>

              {/* Settings/Profile */}
              <button 
                onClick={() => {
                  navigate(isAdmin ? '/settings' : '/profile');
                  setIsOpen(false);
                }}
                className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors w-full"
              >
                <Settings className="h-5 w-5 text-gray-600 dark:text-gray-300 flex-shrink-0" />
                <span className="text-sm font-medium text-gray-900 dark:text-gray-100">{isAdmin ? t('settings') : (language === 'el' ? 'Προφίλ' : 'Profile')}</span>
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className="p-4 border-t border-gray-200 dark:border-gray-700">
            <AuthButton />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};